import _ from 'lodash';
import { GET_ITEMS, DELETE_ITEM, UPDATE_ITEM, UPDATE_ITEMS_ORDER } from 'admin/constants';

const initialState = {
	fetching: false,
	data: {},
};

export default function itemsReducer(state = initialState, action) {
	if (
		[GET_ITEMS.START, DELETE_ITEM.START, UPDATE_ITEMS_ORDER.START, UPDATE_ITEM.START].some(a => a === action.type)
	) {
		return { ...state, fetching: true };
	}

	if ([GET_ITEMS.FAIL, DELETE_ITEM.FAIL, UPDATE_ITEMS_ORDER.FAIL, UPDATE_ITEM.FAIL].some(a => a === action.type)) {
		return { ...state, fetching: false };
	}

	if (action.type === GET_ITEMS.SUCCESS) {
		return { data: action.payload, fetching: false };
	}

	if (action.type === UPDATE_ITEMS_ORDER.SUCCESS) {
		const payload = _.get(action, 'payload', []);
		const newData = payload.reduce((acc, item, index) => {
			acc[`${item.id}`] = item;
			acc[`${item.id}`].order = index;
			return acc;
		}, {});

		return {
			data: newData,
			fetching: false,
		};
	}

	if (action.type === DELETE_ITEM.SUCCESS) {
		return { data: _.omit(state.data, [action.payload.id]), fetching: false };
	}

	if (action.type === UPDATE_ITEM.SUCCESS) {
		return { data: { ...state.data, [action.payload.id]: action.payload }, fetching: false };
	}

	return state;
}
